import { IconButton, SidePanel, TableNew, Text } from '@lune-fe/lune-ui-lib'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined'
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined'
import { Box } from '@mui/material'
import moment from 'moment'
import { FC, useState } from 'react'

import { Report } from 'endpoints/dapi'
import ReportDetails from 'views/CalculateEmissions/Reports/ReportDetails'

const ReportsTableRow: FC<{
    item: Report
}> = ({ item }) => {
    const [sidePanelOpen, setSidePanelOpen] = useState(false)

    const inProgress = item.status === 'progress'
    const failed = item.status === 'failed'
    const title = `${item.type === 'logistics' ? 'Logistics' : 'Spend'} CSV Report`

    return (
        <>
            <TableNew.TableRow
                hover={!inProgress && !failed}
                onClick={() => {
                    if (!inProgress && !failed) {
                        setSidePanelOpen(true)
                    }
                }}
            >
                <TableNew.TableCell
                    colSize={4}
                    sx={{
                        ...(inProgress && {
                            opacity: 0.4,
                        }),
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 1,
                            svg: {
                                color: `TextSecondary`,
                            },
                        }}
                    >
                        <TableChartOutlinedIcon width={20} height={20} />
                        {title}
                    </Box>
                </TableNew.TableCell>
                <TableNew.TableCell
                    colSize={4}
                    sx={{
                        ...(inProgress && {
                            opacity: 0.4,
                        }),
                    }}
                >
                    {moment(item.createdAt).format('ll')}
                </TableNew.TableCell>
                <TableNew.TableCell colSize={3}>{item.fileSize ?? '-'}</TableNew.TableCell>
                <TableNew.TableCell colSize={4}>
                    <Box
                        sx={{
                            padding: 1 / 2,
                            borderRadius: '100px',
                            backgroundColor: inProgress
                                ? `Surface400`
                                : failed
                                  ? `SurfaceError100`
                                  : `SurfaceInfoGreen100`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '30px',
                            minWidth: '94px',
                        }}
                    >
                        <Text
                            variant={'body3'}
                            sx={{
                                px: 1 / 2,
                                color: inProgress
                                    ? `TextPrimary`
                                    : failed
                                      ? `TextError`
                                      : `TextInfoGreen`,
                            }}
                        >
                            {inProgress ? 'In-progress' : failed ? 'Failed' : 'Completed'}
                        </Text>
                    </Box>
                </TableNew.TableCell>
                <TableNew.TableCell
                    onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                    }}
                    alignEnd
                    colSize={1}
                    sx={{
                        '.context-menu': {
                            opacity: 0,
                        },
                        '&:hover': {
                            '.context-menu': {
                                opacity: 1,
                            },
                        },
                    }}
                >
                    {inProgress || failed ? (
                        <IconButton
                            disabled
                            style={'floating'}
                            variant={'secondary'}
                            size={'sm'}
                            leadingIcon={<HourglassEmptyOutlinedIcon />}
                        />
                    ) : (
                        <IconButton
                            style={'floating'}
                            variant={'secondary'}
                            size={'sm'}
                            onClick={() => console.log('download: ', item)}
                            leadingIcon={<FileDownloadOutlinedIcon />}
                        />
                    )}
                </TableNew.TableCell>
            </TableNew.TableRow>
            <SidePanel open={sidePanelOpen} onClose={() => setSidePanelOpen(false)}>
                <ReportDetails item={item} />
            </SidePanel>
        </>
    )
}

export default ReportsTableRow
